const style = {
  name: {
    color: `black`
  },
  userCount: {
    color: `black`
  },
  permCount: {
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/GroupTable/style/ColorBlind/group.js